import React from 'react';

export default function KpiCard(props) {
  var isDark = document.documentElement.classList.contains('tw-dark');
  return (
    <div className="tw-rounded-xl tw-p-4 tw-relative tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
      <div className="tw-absolute tw-top-3 tw-right-3 tw-w-9 tw-h-9 tw-rounded-lg tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: props.color + '18' }}>
        <i className={'fa ' + props.icon} style={{ color: props.color, fontSize: 16 }} />
      </div>
      <div className="tw-text-xs tw-font-medium tw-text-[#999] tw-uppercase tw-tracking-wider" style={{ paddingRight: '44px' }}>{props.label}</div>
      <div className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mt-1">{props.value}</div>
      <div className="tw-text-xs tw-text-[#999] tw-mt-1">{props.change}</div>
    </div>
  );
}
